import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api, setStoredToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const res = await api.post("/auth/google/session", { session_id });
        setStoredToken(res.data.session_token);
        setUser(res.data.user);
        // clear hash and route to dashboard
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { state: { user: res.data.user }, replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-serif text-3xl text-deep-forest">Signing you in…</div>
        <p className="text-deep-forest/60 text-sm mt-3">One moment while we prepare your dashboard.</p>
      </div>
    </div>
  );
}
